import _HtmlEditor from './HtmlEditor'

export const HtmlEditor = _HtmlEditor
